/**
 * Business events that require data assembled from the page.
 * Add future enriched/ecommerce interactions to this file.
 */
(function (window, document) {
  'use strict';

  function getFbtVariant(item) {
    var variantsElement = item.querySelector('[data-fbt-variants]');
    if (!variantsElement) return {};

    try {
      var variants = JSON.parse(variantsElement.textContent || '[]');
      return variants.find(function (variant) {
        return String(variant.id) === String(item.dataset.variantId);
      }) || {};
    } catch (error) {
      console.error('[BusinessEvent] Invalid FBT variant JSON.', item, error);
      return {};
    }
  }

  function getFbtEcommerceItem(item) {
    var variant = getFbtVariant(item);
    var quantityInput = item.querySelector('[data-fbt-quantity]');
    var price = Number(variant.price);

    return {
      item_id: variant.sku || String(variant.id || item.dataset.variantId || ''),
      item_name: item.dataset.productTitle
        || item.querySelector('.fbt__product-title')?.textContent?.trim()
        || '',
      item_category: item.dataset.productCategory || '',
      price: Number.isFinite(price) ? price / 100 : 0,
      item_variant: variant.title === 'Default Title' ? '' : (variant.title || ''),
      quantity: Math.max(1, parseInt(quantityInput?.value, 10) || 1),
      index: Number(item.dataset.itemIndex) || 0,
    };
  }

  function getCurrency() {
    return typeof window.brandTracking?.getCurrency === 'function'
      ? window.brandTracking.getCurrency()
      : '';
  }

  function track(params) {
    if (!window.brandTracking || typeof window.brandTracking.track !== 'function') return null;
    return window.brandTracking.track(params);
  }

  function createFbtEcommerceParams(module, item, eventName, eventLabel) {
    return {
      event: eventName,
      event_category: module.dataset.pageType || 'product_detail',
      event_action: 'click',
      event_label: eventLabel,
      ecommerce: {
        currency: getCurrency(),
        items: [getFbtEcommerceItem(item)],
      },
    };
  }

  function trackFbtSelector(checkbox) {
    var item = checkbox.closest('[data-fbt-item]');
    var module = checkbox.closest('[data-fbt]');
    if (!item || !module) return null;

    var isSelected = checkbox.checked;
    var params = createFbtEcommerceParams(
      module,
      item,
      isSelected ? 'customer_add_to_cart' : 'custom_remove_from_cart',
      isSelected ? 'product_detail_add_to_cart' : 'product_detail_remove_item'
    );

    if (isSelected) {
      delete params.ecommerce.items[0].index;
      params.page_title = document.title;
      params.add_to_cart_source = 'product_detail';
      params.position = 'upsell';
    }

    return track(params);
  }

  function trackFbtQuantity(button) {
    var item = button.closest('[data-fbt-item]');
    var module = button.closest('[data-fbt]');
    if (!item || !module) return null;

    var quantityInput = item.querySelector('[data-fbt-quantity]');
    if (!quantityInput) return null;

    var isIncrease = button.hasAttribute('data-fbt-increase');
    return track(createFbtEcommerceParams(
      module,
      item,
      isIncrease ? 'customer_add_cart_quantity' : 'customer_reduce_cart_quantity',
      isIncrease ? 'product_detail_add_cart_quantity' : 'product_detail_reduce_cart_quantity'
    ));
  }

  function trackCartDiscountDelete(button) {
    var component = button.closest('cart-discount-component');
    if (!component) return null;

    return track({
      event: 'customer_cancel_coupon',
      page_type: 'cart',
      event_action: 'click',
      event_label: 'cart_cancel_coupon',
      coupon_code: button.dataset.code || '',
      position: 'close_button',
    });
  }

  function trackCartCouponApplied(couponCode) {
    return track({
      event: 'customer_apply_coupon',
      page_type: 'cart',
      event_action: 'click',
      event_label: 'cart_apply_coupon',
      coupon_code: couponCode || '',
    });
  }

  function onDocumentChange(event) {
    var checkbox = event.target instanceof Element
      && event.target.matches('[data-fbt-checkbox]')
      ? event.target
      : null;
    if (checkbox) trackFbtSelector(checkbox);
  }

  function onDocumentClick(event) {
    if (!(event.target instanceof Element)) return;

    var discountDeleteButton = event.target.closest('cart-discount-component .discount-del');
    if (discountDeleteButton) {
      trackCartDiscountDelete(discountDeleteButton);
      return;
    }

    var button = event.target.closest('[data-fbt-increase], [data-fbt-decrease]');
    if (!button) return;

    // Capture guarantees the click is observed even if another component
    // stops propagation. Defer payload assembly until the FBT component has
    // synchronously updated the quantity input.
    setTimeout(function () {
      trackFbtQuantity(button);
    }, 0);
  }

  function onCartCouponApplied(event) {
    trackCartCouponApplied(event.detail?.couponCode);
  }

  function init() {
    document.addEventListener('change', onDocumentChange);
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('business:cart:coupon-applied', onCartCouponApplied);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.brandBusinessEvent = window.brandBusinessEvent || {};
  window.brandBusinessEvent.trackFbtSelector = trackFbtSelector;
  window.brandBusinessEvent.trackFbtQuantity = trackFbtQuantity;
  window.brandBusinessEvent.trackCartDiscountDelete = trackCartDiscountDelete;
  window.brandBusinessEvent.trackCartCouponApplied = trackCartCouponApplied;
})(window, document);
